<app-page-page
  [page]="currentPage$ | async">
</app-page-page>
